/* NEXO: open the shirt size guide for the fabric already selected. */
(() => {
  const normalize = (value) => String(value || '').normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '').toLowerCase();

  const guideTab = (value) => {
    const text = normalize(value);
    if (/boxy/.test(text)) return 'nxtD';
    if (/acid\s*(wash|pink)/.test(text)) return 'nxtC';
    if (/peruano|algodon/.test(text)) return 'nxtB';
    if (/seda\s*fria/.test(text)) return 'nxtA';
    return null;
  };

  document.addEventListener('click', (event) => {
    const button = event.target.closest('modal-opener button');
    if (!button) return;
    const opener = button.closest('modal-opener');
    const selector = opener.dataset.modal;
    if (!selector || !selector.startsWith('#')) return;
    const modal = document.getElementById(selector.slice(1));
    const guide = modal?.querySelector('.nxt-sg');
    if (!guide?.querySelector('input[name="nxtsg"]')) return;
    const product = button.closest('product-info, .shopify-section');
    const picker = product?.querySelector('variant-selects');
    if (!picker) return;

    const selected = Array.from(picker.querySelectorAll('input:checked, select option:checked'))
      .map((input) => input.value);
    // A selected cut takes precedence over the fabric if it has its own chart.
    const value = selected.find((text) => /boxy/.test(normalize(text)))
      || selected.find((text) => guideTab(text));
    const tab = guideTab(value || picker.dataset.productTitle);
    const input = tab && guide.querySelector('input[id="' + tab + '"]');
    if (input) input.checked = true;
  }, true);
})();
